import styled from 'styled-components'
import { SPACING, COLORS } from 'utils'

interface CardContainerProps {
  width?: string
  height?: string
  minWidth?: string
  minHeight?: string
  maxWidth?: string
  maxHeight?: string
  padding?: string
  marginTop?: string
}

export const CardContainer = styled.div<CardContainerProps>`
  border-radius: 10px;
  border-top: 10px solid ${COLORS.primary};
  padding: ${({ padding }) => padding ? padding : SPACING.spacing15};
  display: flex;
  flex-direction: column;
  overflow: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  ${({ height }) => (height ? `height: ${height};` : '')}
  ${({ width }) => (width ? `width: ${width};` : '')}
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight};` : '')}
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth};` : '')}
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight};` : '')}
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth};` : '')}
  ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop};` : '')}
`
